import { useGetAssetType } from "@/entities/asset-type";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import AssetTypeForm from "./AssetTypeForm.component";

/**
 * @param {Record<string, unknown> & {assetTypeId?: number}} props
 */
const AssetTypeFormWrapper = ({ assetTypeId }) => {
  const { assetType, isLoading } = useGetAssetType(assetTypeId);

  if (!assetTypeId) return <AssetTypeForm />;

  return (
    <FetchItemWrapper
      item={assetType}
      loading={isLoading}
      renderContent={(assetType) => <AssetTypeForm model={assetType} />}
    />
  );
};

export default AssetTypeFormWrapper;
